import { createContext, useContext } from 'react';
import type { TranslationProviderProps, TranslationFunction } from './types/propsType';

const TranslationContext = createContext<TranslationFunction>(() => '');

const TranslationProvider = ({ children, translationFunction }: TranslationProviderProps): JSX.Element => {
  const defaultFunction: TranslationFunction = () => '';

  return (
    <TranslationContext.Provider value={translationFunction || defaultFunction}>
      <>{children}</>
    </TranslationContext.Provider>
  );
};

const useTranslation = () => {
  const translationFn = useContext(TranslationContext);
  return translationFn;
};

const useMasterdataTranslation = (masterDataName: string) => {
  const translationFn = useContext(TranslationContext);
  const masterDataAppend: TranslationFunction = (str, values) => translationFn(`${masterDataName}.${str}`, values);
  return masterDataAppend;
};

export { useTranslation, useMasterdataTranslation, TranslationProvider };
